import { AppEnvironment } from "./environment.model";

// AUTO-GENERATED by scripts/generate-environment.js from .env-* values.
export const environment: AppEnvironment = {
  production: false,
  name: "development",
  appUrl: "https://invitacion.ismaelypaula.com",
  apiEndpoints: "",
  chatbotApiBaseUrl: "https://api.ismaelypaula.com",
  apis: {
    rmdvp: "",
    eit: "",
    pokemon: "",
    datosAbiertosJda: "",
  },
  keycloak: {
    url: "https://sso.ismaelypaula.com",
    realm: "boda",
    clientId: "asistentes_rag",
  },
};
